import { Theme } from "../../constants/themeConstants";
import { secondaryThemeColors } from "./secondaryThemeColors";

const secondary: Theme = {
  colors: secondaryThemeColors,
  font: {},
};

export default secondary;
